import React, { useState } from "react";

interface Company {
  company_id: number;
  name: string;
  symbol: string;
  sector: string;
  current_price: number;
  day_change: number;
  volume: number;
  market_cap_category: string;
}

interface MarketMoversProps {
  movers: {
    gainers?: Company[];
    losers?: Company[];
    most_active?: Company[];
  } | null;
}

const MarketMovers: React.FC<MarketMoversProps> = ({ movers }) => {
  const [activeTab, setActiveTab] = useState<"gainers" | "losers" | "active">(
    "gainers"
  );

  if (!movers) return null;

  const renderCompanyList = (companies: Company[] | undefined) => {
    if (!companies || companies.length === 0) {
      return (
        <div className="notification is-light has-text-centered">
          <p>No data available</p>
        </div>
      );
    }

    return (
      <div className="movers-list">
        {companies.map((company, index) => (
          <div key={company.company_id} className="mover-item">
            <div className="level is-mobile">
              <div className="level-left">
                <div className="level-item">
                  <span className="has-text-weight-bold mr-2">{index + 1}.</span>
                </div>
                <div className="level-item">
                  <div>
                    <p className="has-text-weight-bold">{company.symbol}</p>
                    <p className="is-size-7 has-text-grey">{company.sector}</p>
                  </div>
                </div>
              </div>
              <div className="level-right">
                <div className="level-item">
                  <div className="has-text-right">
                    <p className="has-text-weight-bold">
                      ₹{company.current_price.toFixed(2)}
                    </p>
                    <p
                      className={`is-size-7 has-text-weight-bold ${
                        company.day_change >= 0
                          ? "has-text-success"
                          : "has-text-danger"
                      }`}
                    >
                      {company.day_change >= 0 ? "+" : ""}
                      {company.day_change.toFixed(2)}%
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="box market-movers mb-5">
      <h2 className="title is-5 mb-4">
        <span className="icon">
          <i className="fa fa-fire"></i>
        </span>
        <span>Market Movers</span>
      </h2>

      <div className="tabs is-toggle is-fullwidth is-small">
        <ul>
          <li className={activeTab === "gainers" ? "is-active" : ""}>
            <a onClick={() => setActiveTab("gainers")}>
              <span className="icon is-small">
                <i className="fa fa-arrow-up"></i>
              </span>
              <span>Gainers</span>
            </a>
          </li>
          <li className={activeTab === "losers" ? "is-active" : ""}>
            <a onClick={() => setActiveTab("losers")}>
              <span className="icon is-small">
                <i className="fa fa-arrow-down"></i>
              </span>
              <span>Losers</span>
            </a>
          </li>
          <li className={activeTab === "active" ? "is-active" : ""}>
            <a onClick={() => setActiveTab("active")}>
              <span className="icon is-small">
                <i className="fa fa-chart-bar"></i>
              </span>
              <span>Most Active</span>
            </a>
          </li>
        </ul>
      </div>

      <div className="tab-content mt-4">
        {activeTab === "gainers" && renderCompanyList(movers.gainers)}
        {activeTab === "losers" && renderCompanyList(movers.losers)}
        {activeTab === "active" && renderCompanyList(movers.most_active)}
      </div>
    </div>
  );
};

export default MarketMovers;
